import { atom } from 'jotai';

import {
  containerArriveAtFacilityAtom,
  containerDepartFacilityAtom,
  containerLoadAtom,
  containerPickupAtom,
  containerReturnToPortAtom,
  containerRevertStatusAtom,
  containerRollAtom,
  containerShipAtom,
  containerUnloadAtom,
  containerVoidAtom,
} from '../_graphql/mutationContainerTransitions';
import {
  containerDeleteAtom,
  containerUpdateAtom,
} from '../_graphql/mutationContainerUpdate';
import { containerDetailQueryAtom } from '../_graphql/queryContainerDetail';
import { tradeRoutePaths as tradeRoutes } from '../routes';
import { ContainerDetailsTab } from '../types/container';

import { atomFromRoutePath } from '~/shared/state';

// 🟣🟣🟣 URL PARAM
export const $containerDetailPathParams = atomFromRoutePath(
  tradeRoutes.containerDetail,
);
export const $containerId = atom((get) =>
  get($containerDetailPathParams)?.id
    ? String(get($containerDetailPathParams)?.id)
    : undefined,
);

// 🔘🔘🔘 LOCAL STATE
export const $activeTab = atom<ContainerDetailsTab>('overview');
export const $isTransitionDialogOpen = atom<boolean>(false);
export const $isRollDialogOpen = atom<boolean>(false);
export const $isVoidDialogOpen = atom<boolean>(false);
export const $isDeleteDialogOpen = atom<boolean>(false);

// 🟢🟢🟢 REMOTE DATA
export const $remoteContainer = containerDetailQueryAtom((get) => {
  const containerId = get($containerId);
  return {
    variables: { id: containerId ?? '' },
    skip: !containerId,
  };
});

// 🟠🟠🟠 ACTIONS
export const $updateContainer = containerUpdateAtom({
  onSuccess: (get) => {
    get($remoteContainer)?.refetch?.();
  },
});

export const $deleteContainer = containerDeleteAtom({
  onSuccess: () => {
    // Navigation will happen in the component
  },
});

export const $voidContainer = containerVoidAtom({
  onSuccess: (get) => {
    get($remoteContainer)?.refetch?.();
  },
});

export const $pickupContainer = containerPickupAtom({
  onSuccess: (get) => {
    get($remoteContainer)?.refetch?.();
  },
});

export const $arriveContainerAtFacility = containerArriveAtFacilityAtom({
  onSuccess: (get) => {
    get($remoteContainer)?.refetch?.();
  },
});

export const $loadContainer = containerLoadAtom({
  onSuccess: (get) => {
    get($remoteContainer)?.refetch?.();
  },
});

export const $departContainerFacility = containerDepartFacilityAtom({
  onSuccess: (get) => {
    get($remoteContainer)?.refetch?.();
  },
});

export const $returnContainerToPort = containerReturnToPortAtom({
  onSuccess: (get) => {
    get($remoteContainer)?.refetch?.();
  },
});

export const $shipContainer = containerShipAtom({
  onSuccess: (get) => {
    get($remoteContainer)?.refetch?.();
  },
});

export const $unloadContainer = containerUnloadAtom({
  onSuccess: (get) => {
    get($remoteContainer)?.refetch?.();
  },
});

export const $rollContainer = containerRollAtom({
  onSuccess: (get) => {
    get($remoteContainer)?.refetch?.();
  },
});

export const $revertContainerStatus = containerRevertStatusAtom({
  onSuccess: (get) => {
    get($remoteContainer)?.refetch?.();
  },
});
